/**
 * Session-storage utilities.
 */

/**
 * Helper for getting values from session storage.
 */
export function getSessionVal(key) {
  if (! window || ! window.sessionStorage) {
    return undefined;
  }

  return window.sessionStorage.getItem(key);
}

/**
 * Helper for setting session storage value.
 */
export function setSessionVal(key, val) {
  if (! window || ! window.sessionStorage) {
    return;
  }

  try {
    window.sessionStorage.setItem(key, val);
  } catch (e) {
    // Session storage full or not available.
  }
}
